import React, { useState, useEffect, useRef } from "react";
import "./ReportPriority.css";
import { ARRYTHMIA_FOLDERS, FIRST_PAGE_IMAGE_PRIORITY } from "../constants/constants";

function ReportPriority({ onClose }) {
  const [items, setItems] = useState([]);
  const [firstPageItems, setFirstPageItems] = useState([]);
  const [activeTab, setActiveTab] = useState("first");

  const dragItem = useRef(null);
  const dragOverItem = useRef(null);

  useEffect(() => {

  // 🔹 Arrhythmia
  const savedArr = localStorage.getItem("report_priority_arrhythmia");

    if (savedArr) {
      const savedItems = JSON.parse(savedArr);

      const merged = [
        ...savedItems,
        ...ARRYTHMIA_FOLDERS.filter(
          d => !savedItems.some(s => s.key === d.key)
        )
      ];

      setItems(merged);
    } else {
      setItems(ARRYTHMIA_FOLDERS);
    }

    // 🔹 First Page
    const savedFirst = localStorage.getItem("report_priority_first_page");

    if (savedFirst) {
      const savedItems = JSON.parse(savedFirst);

      const merged = [
        ...savedItems,
        ...FIRST_PAGE_IMAGE_PRIORITY.filter(
          d => !savedItems.some(s => s.key === d.key)
        )
      ];

      setFirstPageItems(merged);
    } else {
      setFirstPageItems(FIRST_PAGE_IMAGE_PRIORITY);
    }

  }, []);

  const updateStorage = (list) => {

    if (activeTab === "arrhythmia") {
      localStorage.setItem(
        "report_priority_arrhythmia",
        JSON.stringify(list)
      );
    } else {
      localStorage.setItem(
        "report_priority_first_page",
        JSON.stringify(list)
      );
    }

    window.dispatchEvent(new Event("priorityUpdated"));
  };

  const handleDragStart = (index) => {
    dragItem.current = index;
  };

  const handleDragEnter = (index) => {
    dragOverItem.current = index;
  };

  const handleDrop = () => {
    if (
      dragItem.current === null ||
      dragOverItem.current === null
    ) return;

    const copyList =
      activeTab === "arrhythmia"
        ? [...items]
        : [...firstPageItems];
    const dragItemContent = copyList[dragItem.current];

    copyList.splice(dragItem.current, 1);
    copyList.splice(dragOverItem.current, 0, dragItemContent);

    dragItem.current = null;
    dragOverItem.current = null;

    if (activeTab === "arrhythmia") {
      setItems(copyList);
    } else {
  setFirstPageItems(copyList);
}
    updateStorage(copyList);
  };

  const displayList =
    activeTab === "arrhythmia" ? items : firstPageItems;

  return (
    <div className="priority-container">

      {/* 🔥 HEADER (like modal) */}
      <div className="priority-header">
        <h3>Report Section Priority</h3>
        <span className="close-btn" onClick={onClose}>×</span>
      </div>

      {/* 🔥 TAB UI */}
      <div className="priority-tabs">
        <button
          className={activeTab === "first" ? "active" : ""}
          onClick={() => setActiveTab("first")}
        >
          Front Page
        </button>

        <button
          className={activeTab === "arrhythmia" ? "active" : ""}
          onClick={() => setActiveTab("arrhythmia")}
        >
          Others
        </button>
      </div>

      {/* 🔥 LIST WRAPPER */}
      <div className="priority-list">
        {displayList.map((item, index) => (
          <div
            key={item.key}
            className="priority-item"
            draggable={true}
            onDragStart={() => handleDragStart(index)}
            onDragEnter={() => handleDragEnter(index)}
            onDragOver={(e) => e.preventDefault()}
            onDrop={handleDrop}
          >
            {item.name}
          </div>
        ))}
      </div>

    </div>
  );
}

export default ReportPriority;